// @flow
import * as React from 'react';

import type { Context } from '../types';

export default React.createContext<Context>({
  show: unusedMessage => undefined,
});
